import { render, staticRenderFns } from "./PrivacyPolicyBase.vue?vue&type=template&id=19abf35c&scoped=true"
import script from "./PrivacyPolicyBase.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyBase.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyBase.vue?vue&type=style&index=0&id=19abf35c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19abf35c",
  null
  
)

export default component.exports